"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformWorkspaceProjectEventToJSON = exports.transformJSONToWorkspaceProjectEvent = void 0;

var _workspaceProjectActivatedEvent = require("./workspace-project-activated-event");

var _workspaceProjectArchivedEvent = require("./workspace-project-archived-event");

var _workspaceProjectCreatedEvent = require("./workspace-project-created-event");

var _workspaceProjectDeletedEvent = require("./workspace-project-deleted-event");

var _workspaceProjectStyleguideLinkedEvent = require("./workspace-project-styleguide-linked-event");

var _workspaceProjectStyleguideUnlinkedEvent = require("./workspace-project-styleguide-unlinked-event");

var _workspaceProjectUpdatedEvent = require("./workspace-project-updated-event");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformJSONToWorkspaceProjectEvent = function transformJSONToWorkspaceProjectEvent(value) {
  switch (value.action) {
    case 'activated':
      return (0, _workspaceProjectActivatedEvent.transformJSONToWorkspaceProjectActivatedEvent)(value);

    case 'archived':
      return (0, _workspaceProjectArchivedEvent.transformJSONToWorkspaceProjectArchivedEvent)(value);

    case 'created':
      return (0, _workspaceProjectCreatedEvent.transformJSONToWorkspaceProjectCreatedEvent)(value);

    case 'deleted':
      return (0, _workspaceProjectDeletedEvent.transformJSONToWorkspaceProjectDeletedEvent)(value);

    case 'styleguide_linked':
      return (0, _workspaceProjectStyleguideLinkedEvent.transformJSONToWorkspaceProjectStyleguideLinkedEvent)(value);

    case 'styleguide_unlinked':
      return (0, _workspaceProjectStyleguideUnlinkedEvent.transformJSONToWorkspaceProjectStyleguideUnlinkedEvent)(value);

    case 'updated':
      return (0, _workspaceProjectUpdatedEvent.transformJSONToWorkspaceProjectUpdatedEvent)(value);

    default:
      throw new Error("No variant of WorkspaceProjectEvent exists with 'action=".concat(value.action, "'"));
  }
};

exports.transformJSONToWorkspaceProjectEvent = transformJSONToWorkspaceProjectEvent;

var transformWorkspaceProjectEventToJSON = function transformWorkspaceProjectEventToJSON(value) {
  switch (value.action) {
    case 'activated':
      return (0, _workspaceProjectActivatedEvent.transformWorkspaceProjectActivatedEventToJSON)(value);

    case 'archived':
      return (0, _workspaceProjectArchivedEvent.transformWorkspaceProjectArchivedEventToJSON)(value);

    case 'created':
      return (0, _workspaceProjectCreatedEvent.transformWorkspaceProjectCreatedEventToJSON)(value);

    case 'deleted':
      return (0, _workspaceProjectDeletedEvent.transformWorkspaceProjectDeletedEventToJSON)(value);

    case 'styleguide_linked':
      return (0, _workspaceProjectStyleguideLinkedEvent.transformWorkspaceProjectStyleguideLinkedEventToJSON)(value);

    case 'styleguide_unlinked':
      return (0, _workspaceProjectStyleguideUnlinkedEvent.transformWorkspaceProjectStyleguideUnlinkedEventToJSON)(value);

    case 'updated':
      return (0, _workspaceProjectUpdatedEvent.transformWorkspaceProjectUpdatedEventToJSON)(value);
  }
};
/**
 * @type WorkspaceProjectEvent
 * This event is used to notify webhooks about changes directly related to Zeplin projects:  - Project is created or deleted  - Project\'s linked styleguide changes  - Any of these properties change:    - name    - description    - density scale (1x, 2x, etc.)    - thumbnail image    - status (archived or activated)    - rem preferences (web projects only)\" 
 * @export
 */


exports.transformWorkspaceProjectEventToJSON = transformWorkspaceProjectEventToJSON;